import React from "react";
import { sidemenuFooterWrap } from "../componentCommon";
import { Link } from "react-router-dom";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import "../../index.scss";
import "./Responsive.scss";
import "./Artists.scss";

const ArtistsData = () => (
  <Container
    className="container-artists"
    sm={{ span: 12 }}
    md={{ span: 12 }}
    lg={{ span: 12 }}
    xl={{ span: 12 }}
  >
    <Row>
      <Col
        sm={{ span: 12 }}
        md={{ span: 11, offset: 1 }}
        lg={{ span: 11, offset: 1 }}
        xl={{ span: 11, offset: 0 }}
      >

        <div style={{ alignText: "center", fontFamily: "Verdana, arial" }} className="artists-title">
        UMETNICI
        </div>

        <Row className="artists-r">
          <Col md={{ span: 10 }}>
            <Row>
              <div style={{ alignItems: "center" }}>
                <Row
                  xs={{ span: 12 }}
                  sm={{ span: 12 }}
                  md={{ span: 12 }}
                  lg={{ span: 12 }}
                  xl={{ span: 12 }}
                >
                  <Col
                    xs={{ span: 12 }}
                    sm={{ span: 12 }}
                    md={{ span: 12 }}
                    lg={{ span: 4 }}
                    xl={{ span: 4 }}
                  >
                    <Link to="/g/petar-lubarda" className="im-link">
                      <img src="images/umetnik_1_srednja3.jpg" alt="lubarda, petar, citajte o" />
                    </Link>
                  </Col>
                  <Col
                    xs={{ span: 10 }}
                    sm={{ span: 7, offset: 0 }}
                    md={{ span: 7, offset: 0 }}
                    lg={{ span: 5, offset: 1 }}
                    xl={{ span: 6, offset: 0 }}
                  >
                    <div className="artist-p">
                      <font color="black">
                        <b>PETAR LUBARDA</b>
                      </font>{" "}
                      je rođen 1907. u Ljubotinju nedaleko od Cetinja, od oca Đura
                      I. Lubarde, oficira crnogorske vojske, a potom potpukovnika
                      Vojske Kraljevine Jugoslavije, i majke Marije M. Vujović,
                      domaćice. Imao je petoro braće i sestara.
                      <Link to="/g/petar-lubarda">
                        <br />
                        dalje...
                      </Link>
                      <Link to="/g/petar-lubarda">
                        <img
                          width="15"
                          src="images/strelica.jpg"
                          alt="citajte o, lubarda, sumanovic, nadezda petrovic"
                        />
                      </Link>
                    </div>
                  </Col>
                </Row>
              </div>
              <div style={{ marginTop: "3%" }}>
                <Row
                  xs={{ span: 12 }}
                  sm={{ span: 12 }}
                  md={{ span: 12 }}
                  lg={{ span: 12 }}
                  xl={{ span: 12 }}
                >
                  <Col
                    xs={{ span: 12 }}
                    sm={{ span: 12 }}
                    md={{ span: 12 }}
                    lg={{ span: 4 }}
                    xl={{ span: 4 }}
                  >
                    <Link to="/g/sava-sumanovic" className="im-link">
                      <img src="images/umetnik_2_srednja3.jpg" alt="lubarda, petar, citajte o" />
                    </Link>
                  </Col>
                  <Col
                    xs={{ span: 10 }}
                    sm={{ span: 7 }}
                    md={{ span: 7, offset: 0 }}
                    lg={{ span: 5, offset: 1 }}
                    xl={{ span: 6, offset: 0 }}
                  >
                    <div className="artist-p">
                      <font color="black">
                        <b>SAVA ŠUMANOVIĆ</b>
                      </font>{" "}
                      je rođen 24. januara 1896. u Vinkovcima u imućnoj građanskoj
                      porodici, Perside i Milutina Šumanovića. Posle ranog očevog
                      penzionisanja 1900. porodica se vraća u Šid, gde Sava pohađa
                      osnovnu školu.
                      <Link to="/g/sava-sumanovic">
                        <br />
                        dalje...
                      </Link>
                      <Link to="/g/sava-sumanovic">
                        <img width="15" src="images/strelica.jpg" alt="citajte o, lubarda, sumanovic, nadezda petrovic" />
                      </Link>
                    </div>
                  </Col>
                </Row>
              </div>
              <div style={{ marginTop: "3%" }}>
                <Row
                  xs={{ span: 12 }}
                  sm={{ span: 12 }}
                  md={{ span: 12 }}
                  lg={{ span: 12 }}
                  xl={{ span: 12 }}
                >
                  <Col
                    xs={{ span: 12 }}
                    sm={{ span: 12 }}
                    md={{ span: 12 }}
                    lg={{ span: 4 }}
                    xl={{ span: 4 }}
                  >
                    <Link to="/g/nadezda-petrovic" className="im-link">
                      <img src="images/nadezda-petrovic-s3.jpg"  alt="lubarda, petar, citajte o" />
                    </Link>
                  </Col>
                  <Col
                    xs={{ span: 10 }}
                    sm={{ span: 7 }}
                    md={{ span: 7, offset: 0 }}
                    lg={{ span: 5, offset: 1 }}
                    xl={{ span: 6, offset: 0 }}
                  >
                    <div className="artist-p" style={{ marginBottom: '5em' }}>
                      <font color="black">
                        <b>NADEŽDA PETROVIĆ</b>
                      </font>{" "}
                      je rođena 11. oktоbra 1873. u Čačku. Otac Dimitrije Mita
                      Petrović bio je nastavnik crtanja u Realnoj gimnaziji u Čačku,
                      a majka Mileva učiteljica. Nadežda je bila najstarije od
                      devetoro dece.
                      <Link to="/g/nadezda-petrovic">
                        <br />
                        dalje...
                      </Link>
                      <Link to="/g/nadezda-petrovic">
                        <img
                          width="15"
                          src="images/strelica.jpg"
                          alt="citajte o, lubarda, sumanovic, nadezda petrovic"
                        />
                      </Link>{" "}
                    </div>
                  </Col>
                </Row>
              </div>
            </Row>
          </Col>
        </Row>

      </Col>    
    </Row>

  </Container>
);

const Artists = sidemenuFooterWrap(ArtistsData);
export default Artists;
